// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nf-0";